import { TiptapEditor } from "../tiptap/TiptapEditor";

export function Editor({
  editorSerializedState,
  onSerializedChange,
  onMarkdownChange,
  readOnly = false,
}: {
  editorState?: any;
  editorSerializedState?: any;
  onChange?: (editorState: any) => void;
  onSerializedChange?: (editorSerializedState: any) => void;
  onMarkdownChange?: (markdown: string) => void;
  readOnly?: boolean;
}) {
  return (
    <TiptapEditor
      content={editorSerializedState}
      onJSONChange={onSerializedChange}
      onMarkdownChange={onMarkdownChange}
      readOnly={readOnly}
      variant="full"
    />
  );
}
